import { observable } from 'mobx';

export interface Product {
  Description: string;
  ItemNo: string;
  Key: string;
  Inventory: string;
  UnitOfMeasure: string;
  ItemCategoryCode: string;
  ItemCategoryDesc: string;
  image?: string;
  image_thumb?: string;
  GrossWeight?: string;
  Reserved?: string;
}

export interface NavOrderResult {
  navOrder: NAVOrder;
  status: 'success' | 'error';
}

export interface Result {
  status: string;
  message: string;
  orders: NavOrderResult[];
}

export interface CartProduct extends Product {
  Quantity: number;
  company: string;
}

// @TODO Add other components as well
export interface Order {
  products: Array<Product>;
}

export interface Cart {
  products: Array<CartProduct>;
}

export interface Customer {
  Address: string;
  City: string;
  Key: string;
  Name: string;
  Name2: string;
  No: string;
  Post_Code: string;
  company: string;
  Phone_No?: string;
  E_Mail?: string;
  Address2?: string;
}

export interface Notification {
  type: string;
  message: string;
  seen: boolean;
}

export interface WLines {
  WebOrderLineWS_PTE: Array<CartProduct>;
}

export class NAVOrder {
  @observable public OrderId: string;
  @observable public CustomerId: string;
  @observable public SalesPersonId: string;
  @observable public OrderDate: string;
  @observable public ShipDate: string;
  @observable public Reference: string;
  @observable public Reference2: string;
  @observable public Name: string;
  @observable public Name2: string;
  @observable public ShipAddr1: string;
  @observable public ShipAddr2: string;
  @observable public ShipCity: string;
  @observable public ShipZip: string;
  @observable public ShipContact: string;
  @observable public EMail: string;
  @observable public Phone: string;
  @observable public WLines: WLines;
  @observable public ReasonCode: string;
  @observable public AlreadyPicked: boolean;
  @observable public EmailConfirmation: boolean;
  @observable public YourReference2: string;
  constructor() {
    this.OrderId = '';
    this.CustomerId = '';
    this.SalesPersonId = '';
    this.OrderDate = '';
    this.ShipDate = '';
    this.Reference = '';
    this.Reference2 = '';
    this.Name = '';
    this.Name2 = '';
    this.ShipAddr1 = '';
    this.ShipAddr2 = '';
    this.ShipCity = '';
    this.ShipZip = '';
    this.ShipContact = '';
    this.EMail = '';
    this.WLines = { WebOrderLineWS_PTE: [] };
    this.ReasonCode = '';
    this.AlreadyPicked = false;
    this.EmailConfirmation = false;
    this.YourReference2 = '';
  }
}

export interface OrderType {
  Description: string;
  Key: string;
  ReasonCode: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/interfaces.ts